import * as React from 'react';
import { VStack, Text, Image, Box } from '@chakra-ui/react';
import { StyleDTO } from 'core/api';
import * as Images from '../Images';
import { Colors } from 'core/ui';
import { useClickWithFeedback } from './useClickWithFeedback';

export function toShortUserName(userName: string): string {
	// Me quedo sólo con las letras y me quedo con las dos primeras
	return userName.toUpperCase().replace(/[^a-zA-ZÁÉÍÓÚÑÜ]/g, '').slice(0, 2);
}

export function UserButton<TUser extends { Id: number, Name: string, Style: StyleDTO }>({ user, onSelect: onSelect, selected }: { user: TUser, onSelect: (user: TUser) => void, selected?: boolean }) {

	const hasImage = !(user.Style.ImageId === Images.NULL_IMAGE || user.Style.ImageId === '');
	const onUserSelected = React.useCallback(() => onSelect(user), [onSelect, user]);
	const backgroundColor = Colors.getBackgroundColorAsRgb(user.Style.BackColor);

	return <VStack width={'full'} gap={'1'} cursor={'pointer'}
		{...useClickWithFeedback(onUserSelected)}>

		<UserImage hasImage={hasImage} selected={selected} user={user} backgroundColor={backgroundColor} />

		<Text width={'full'} fontWeight={selected ? 'semibold' : 'regular'} fontSize={'sm'} textAlign={'center'} lineClamp={'2'} color={selected ? 'info' : 'default'}>
			{user.Style.Text}
		</Text>
	</VStack>;
}

function UserImage<TUser extends { Id: number; Name: string; Style: StyleDTO; }>({ hasImage, selected, user, backgroundColor }: { hasImage: boolean, selected?: boolean, user: TUser, backgroundColor: string }): React.ReactNode {
	if (!hasImage)
		return <Box display={'flex'} alignItems={'center'} justifyContent={'center'} fontWeight={'bold'} fontSize={'lg'} h={'14'} w={'14'} rounded={'full'} bg={backgroundColor} color={Colors.getTextColor(backgroundColor)}>
			<Text>{toShortUserName(user.Style.Text)}
			</Text>
		</Box>;

	const theImage = <Image src={Images.imgSrcFromId(user.Style.ImageId)} boxSize={'14'} borderRadius={'full'} fit={'cover'} alt={user.Style.Text} />;

	return selected
		? <Box h={'18'} w={'18'} borderRadius={'full'} borderColor={'info'} borderWidth={'1px'} shadow={'md'} justifyContent={'center'} alignItems={'center'} display={'flex'}>{theImage}</Box>
		: theImage;
}